import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

/**
 * Invisible, mounted once outside <Routes> so it sees every route change.
 * Fires a visit event on first load and on every route change, for both
 * logged-in and anonymous visitors. hubId is resolved server-side from the
 * logged-in user's primary address — the frontend only needs to send userId.
 */
export default function HubVisitTracker() {
  const location = useLocation();
  const firedForPath = useRef(null);

  useEffect(() => {
    // Guards against React.StrictMode's dev-only double-invoke of effects,
    // which would otherwise record two visits for the same route change.
    if (firedForPath.current === location.pathname) return;
    firedForPath.current = location.pathname;

    let sessionId = sessionStorage.getItem("hubVisitSessionId");
    let isNewSession = false;
    if (!sessionId) {
      sessionId =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem("hubVisitSessionId", sessionId);
      isNewSession = true;
    }

    let userId = null;
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      userId = user?._id || null;
    } catch {
      userId = null;
    }

    axios
      .post(
        "/tracking/visit",
        {
          sessionId,
          userId,
          path: location.pathname,
          referrer: document.referrer || "",
          isNewSession,
        },
        { baseURL: "https://dailydish.in/api" },
      )
      .catch((err) => console.log("track visit failed", err.message));
  }, [location.pathname]);

  return null;
}
